import { useTranslation } from 'react-i18next';
import { FamilyStatus } from '../../participantEnums';

export const useFamilyStatuses = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: FamilyStatus.SINGLE_NO_CHILDREN,
      label: t('participants.enums.familyStatus.SINGLE_NO_CHILDREN'),
    },
    {
      value: FamilyStatus.COUPLE_NO_CHILDREN,
      label: t('participants.enums.familyStatus.COUPLE_NO_CHILDREN'),
    },
    {
      value: FamilyStatus.SINGLE_WITH_CHILDREN,
      label: t('participants.enums.familyStatus.SINGLE_WITH_CHILDREN'),
    },
    {
      value: FamilyStatus.COUPLE_WITH_CHILDREN,
      label: t('participants.enums.familyStatus.COUPLE_WITH_CHILDREN'),
    },
  ];
};
